import * as React from 'react';
import {
  FACompsBySeasonDate,
  FAComps,
  FACompCurrentRounds,
} from '@nls-2022/nls-bll';
import {computeHeadingLevel} from '@testing-library/react';
import {FACompBlogContentType, FACompDetailsType} from '@nls-2022/nls-bll';
import {Select} from './BlogFormInputs';
export type BlogPostSelectRoundPropsType = {
  handleRoundChange: any;
  selectedSeason: string;
  selectedComp: string | undefined | null;
  selectedRound: string | undefined | null;
};

//const Select = ({register, name, options, defaultValue, ...rest}: any) => {
//  return (
//    <select defaultValue={defaultValue} {...register(name)} {...rest}>
//      {options.map((option: string, index: string) => (
//        <option value={option} key={index}>
//          {option}
//        </option>
//      ))}
//    </select>
//  );
//};

const BlogPostSelectRoundBaseV2 = ({
  register,
  selectedSeason,
  selectedComp,
  selectedRound,
}: any) => {
  console.log(
    'in BaseRound2 ' +
      selectedSeason +
      '-' +
      selectedComp +
      '-' +
      selectedRound,
  );
  if (
    selectedComp === undefined ||
    selectedComp === null ||
    selectedComp === ''
  ) {
    return <></>;
  }
  let faComp = FAComps.find((u: {name: any}) => {
    return u.name === selectedComp;
  });
  let roundNames: Array<string> | undefined = FACompCurrentRounds?.find(
    (u: {comp: any}) => {
      return u.comp === faComp?.comp;
    },
  )?.roundNames!;

  return (
    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Round
      </label>

      <Select
        name="Round"
        register={register}
        options={roundNames}
        defaultValue={selectedRound}
      />
    </div>
  );
};
export default BlogPostSelectRoundBaseV2;
